import React from 'react';
import { 
  Grid3X3, 
  Plus, 
  Store, 
  Users, 
  ChevronRight, 
  MoreVertical,
  Search,
  Filter
} from 'lucide-react';

export const RetailerGroups: React.FC = () => {
  const groups = [
    { name: 'Premium Outlets', count: 24, value: '₹4.2L', color: 'bg-indigo-500' },
    { name: 'Suburban Stores', count: 45, value: '₹2.8L', color: 'bg-emerald-500' },
    { name: 'Wholesale Hubs', count: 12, value: '₹8.5L', color: 'bg-amber-500' },
    { name: 'New Onboarding', count: 8, value: '₹0.4L', color: 'bg-purple-600' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-black text-text">Retailer Groups</h1>
          <p className="text-text2">Segment your retailers for targeted assignments and reporting</p>
        </div>
        <button className="btn-primary flex items-center gap-2">
          <Plus size={16} />
          Create New Group
        </button>
      </div>

      <div className="flex items-center gap-4 mb-8">
        <div className="relative flex-1 max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-text3" size={16} />
          <input type="text" placeholder="Search groups..." className="w-full h-10 pl-10 pr-4 bg-white border border-border rounded-lg text-sm focus:border-primary outline-hidden" />
        </div>
        <button className="p-2 border border-border rounded-lg text-text3 hover:bg-gray-50">
          <Filter size={18} />
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {groups.map((group, i) => (
          <div key={i} className="card p-6 group hover:border-primary transition-all cursor-pointer">
            <div className={`w-12 h-12 rounded-2xl ${group.color} flex items-center justify-center text-white mb-6 shadow-lg group-hover:scale-110 transition-transform`}>
              <Grid3X3 size={24} />
            </div>
            <h3 className="text-lg font-black text-text mb-1">{group.name}</h3>
            <div className="flex items-center justify-between text-[10px] font-bold text-text3 uppercase tracking-widest mb-4">
              <span>{group.count} Retailers</span>
              <span className="text-primary">{group.value} MTD</span>
            </div>
            <div className="flex -space-x-2 mb-6">
              {[1, 2, 3, 4].map(j => (
                <div key={j} className="w-8 h-8 rounded-full border-2 border-white bg-gray-100 flex items-center justify-center text-[10px] font-bold text-text3">
                  {String.fromCharCode(64 + j)}
                </div>
              ))}
              <div className="w-8 h-8 rounded-full border-2 border-white bg-gray-50 flex items-center justify-center text-[8px] font-bold text-text3">
                +{group.count - 4}
              </div>
            </div>
            <button className="w-full h-10 border border-border rounded-xl text-xs font-bold text-text2 group-hover:bg-primary group-hover:text-white group-hover:border-primary transition-all flex items-center justify-center gap-2">
              View Group
              <ChevronRight size={14} />
            </button>
          </div>
        ))}

        <button className="h-full border-2 border-dashed border-border rounded-[24px] flex flex-col items-center justify-center p-8 text-text3 hover:border-primary hover:text-primary transition-all group">
          <div className="w-12 h-12 rounded-2xl bg-gray-50 flex items-center justify-center mb-4 group-hover:bg-primary/10 transition-colors">
            <Plus size={24} />
          </div>
          <span className="font-bold text-sm">Add Custom Group</span>
        </button>
      </div>
    </div>
  );
};
